module.exports = __webpack_public_path__ + "img/introduction-banner.ad8a1a4f.svg";